import React from 'react';

const Hero = ({ scrollToSection }) => {
  return (
    <section className="hero" id="home">
      <div id="main-content"></div>
      <div className="hero-content">
        <div className="hero-tag">{'// ENTERPRISE IT CONSULTING'}</div>
        <h1>BUILDING<br /><span className="highlight">RESILIENT</span><br />DIGITAL<br />PLATFORMS</h1>
        <p>Gades Group partners with enterprises to architect, implement, and scale cloud, data, and AI solutions that deliver measurable business outcomes.</p>
        <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem', flexWrap: 'wrap' }}>
          <button className="hero-cta" onClick={() => scrollToSection('services')}>EXPLORE SERVICES →</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
